<script>
	import Button from '../Button.svelte';
    import { _ } from 'svelte-i18n';
    import { navigate } from "svelte-routing";
</script>

<style>
    .not-found {
        background-color: var(--colorBgVariant);
        padding: var(--spacingXXXLarge) var(--spacingXXLarge);
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    p {
        margin-bottom: var(--spacingXXXLarge);
        font-style: italic;
    }
</style>

<div class="not-found">
    <h1>{$_('not_found_header')}</h1>
    <p>{$_('not_found')}</p>

    <Button on:click={() => navigate('/')}>{$_('not_found_button')}</Button>
</div>